import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useState,
} from 'react';
import { modeType } from '@models/mode';
import TopUpsItemDto from '../models/dto/top-ups-item.dto';

interface UserMutationContextData {
  stepIndex: number;
  setStepIndex: Dispatch<SetStateAction<number>>;
  mode: modeType;
  setMode: Dispatch<SetStateAction<modeType>>;
  payload: TopUpsItemDto | undefined;
  setPayload: Dispatch<SetStateAction<TopUpsItemDto | undefined>>;
}

export const TopUpsMutationContext = createContext<
  UserMutationContextData | undefined
>(undefined);

const TopUpsMutationProvider = ({ children }: { children: ReactNode }) => {
  const [stepIndex, setStepIndex] = useState<number>(0);
  const [mode, setMode] = useState<modeType>('create');
  const [payload, setPayload] = useState<TopUpsItemDto | undefined>();

  return (
    <TopUpsMutationContext.Provider
      value={{
        stepIndex,
        setStepIndex,
        mode,
        setMode,
        payload,
        setPayload,
      }}
    >
      {children}
    </TopUpsMutationContext.Provider>
  );
};

export default TopUpsMutationProvider;
